import React from "react";
import { TextInput } from "components/shared/input/text-input/TextInput";
interface EnterNameProps {
  onRoomCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  roomCode: string;
  showRoomCodeInput: boolean;
}
export const EnterName: React.FC<EnterNameProps> = ({
  onRoomCodeChange,
  onNameChange,
  name,
  roomCode,
  showRoomCodeInput,
}) => {
  return (
    <>
      {showRoomCodeInput && (
        <TextInput
          iconId="video-camera"
          type="text"
          id="room"
          placeholder="Enter Room Code"
          value={roomCode}
          onChange={onRoomCodeChange}
        />
      )}
      <TextInput
        iconId="profile"
        type="text"
        id="name"
        placeholder="Enter Name"
        value={name}
        onChange={onNameChange}
        autocomplete="cc-csc"
      />
    </>
  );
};
